const categoryFilterGroup = (selectedCategories = []) => {
    if(selectedCategories.length) {
        return [
            selectedCategories.map(categoryKey => ({
                key: "category",
                value: categoryKey
            }))
        ];
    }
    return [];
};

export default categoryFilterGroup;
